import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import StatusChip from "../StatusChip";
import { errMsg } from "../../lib/portfolio";

export function ReviewersPanel({ projectId }) {
  const [items, setItems] = useState([]);
  const [email, setEmail] = useState("");
  const [notInTenant, setNotInTenant] = useState(false);
  const load = useCallback(() => {
    api.get(`/admin/portfolio/projects/${projectId}/reviewers`).then((r) => setItems(r.data.items)).catch(() => {});
  }, [projectId]);
  useEffect(() => { load(); }, [load]);

  const invite = async (e) => {
    e.preventDefault();
    setNotInTenant(false);
    try {
      await api.post(`/admin/portfolio/projects/${projectId}/reviewers`, { email });
      toast.success("Reviewer added. They will see this project in Portfolio Manager.");
      setEmail("");
      load();
    } catch (err) {
      if (err?.response?.data?.detail?.code === "portfolio_reviewer_not_in_tenant") setNotInTenant(true);
      toast.error(errMsg(err));
    }
  };
  const revoke = async (id) => {
    try { await api.delete(`/admin/portfolio/projects/${projectId}/reviewers/${id}`); toast.success("Access revoked."); load(); }
    catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="space-y-3" data-testid="portfolio-reviewers-panel">
      <form onSubmit={invite} className="flex flex-col sm:flex-row gap-2 sm:items-end">
        <div className="flex-1 min-w-0">
          <Label htmlFor="pf-reviewer-email" className="font-nav text-erf-dark">Reviewer email (existing workspace user)</Label>
          <Input id="pf-reviewer-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="mt-1 min-h-[44px] bg-white text-erf-dark" data-testid="portfolio-reviewer-email" />
        </div>
        <Button type="submit" className="bg-erf-gold text-erf-dark hover:bg-erf-goldHover" data-testid="portfolio-reviewer-invite-btn">
          Invite reviewer
        </Button>
      </form>
      {notInTenant && (
        <p className="text-sm font-nav text-erf-dark" data-testid="portfolio-reviewer-not-in-tenant">
          That person doesn't have an account yet. Invite them from{" "}
          <Link to="/admin/people-roles/users" className="underline text-erf-dark">People &amp; Access</Link> first, then add them here.
        </p>
      )}
      {items.length === 0 ? (
        <p className="text-sm font-nav text-erf-dark/70">No reviewers yet.</p>
      ) : (
        <ul className="divide-y divide-erf-borderCream">
          {items.map((r) => (
            <li key={r.id} className="flex flex-wrap items-center gap-2 py-2" data-testid={`portfolio-reviewer-${r.id}`}>
              <span className="flex-1 min-w-0 text-sm font-nav text-erf-dark ds-text-safe">{r.user_name || r.user_email}</span>
              <StatusChip status={r.accepted_at ? "verified" : "pending"} label={r.accepted_at ? "Accepted" : "Invited"} />
              <Button variant="outline" className="border-[#FECACA] text-[#991B1B]" onClick={() => revoke(r.id)}
                data-testid={`portfolio-reviewer-revoke-${r.id}`}>Revoke</Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
